// extracted by mini-css-extract-plugin
export default {"predict-button-group":"plate-number-predict_predict-button-group__bA+14","show":"plate-number-predict_show__BSpjc"};